import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Input, Button } from "antd";
import { CONFIG } from "../config";
import { saveAuth } from "../utils/auth";
import "./LoginPage.css";

const LoginPage = () => {
  const [id, setId] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setIsLoading(true);

    try {
      const response = await axios.post(`${CONFIG.BACKEND_URL}/auth/login`, {
        id,
        pw: password,
      });

      const { result, data, message } = response.data;

      if (result === "SUCCESS") {
        saveAuth(data.user, data.token);
        navigate("/overview");
      } else {
        setError(message || "로그인에 실패했습니다.");
      }
    } catch (err) {
      const apiMessage = err.response?.data?.message;
      setError(apiMessage || "로그인에 실패했습니다. 다시 시도해주세요.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-header">
          <img alt="client logo" src="assets/client_vertical_logo.png" />
          <h2>원페를라 물류로봇 운영 시스템</h2>
          <div>
            <p>Powered by</p>
            <img
              width="138px"
              alt="sollink logo"
              src="assets/sollink_logo.png"
            />
          </div>
        </div>

        <form className="login-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <Input
              type="text"
              id="id"
              value={id}
              onChange={(e) => setId(e.target.value)}
              placeholder="아이디를 입력해주세요."
              required
              disabled={isLoading}
              size="large"
              style={{ height: "56px" }}
              block
            />

            <Input.Password
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="비밀번호를 입력해주세요."
              required
              disabled={isLoading}
              size="large"
              block
              style={{ height: "56px" }}
            />
          </div>

          <div
            className="error-message"
            style={{
              visibility: error ? "visible" : "hidden",
              minHeight: "26px",
            }}
          >
            {error || "\u00A0"}
          </div>

          <Button
            style={{
              background: "#003D48",
              color: "#fff",
              marginTop: "6px",
              height: 56,
            }}
            htmlType="submit"
            className="login-button"
            disabled={isLoading}
            loading={isLoading}
            size="large"
            block
          >
            로그인
          </Button>
        </form>
      </div>
    </div>
  );
};

export default LoginPage;
